import { cn } from '@/lib/utils'
import type { ValidationCount, ValidationStatus } from '../types'

interface ValidationBadgeProps {
  counts: ValidationCount
  status: ValidationStatus
  label?: string
}

const STATUS_DOT_COLOR: Record<ValidationStatus, string> = {
  pass: 'text-success',
  warn: 'text-amber-500',
  fail: 'text-red-500',
  idle: 'text-muted-foreground',
}

export function ValidationBadge({ counts, status, label }: ValidationBadgeProps) {
  const dotColor = STATUS_DOT_COLOR[status]
  const hasIssues = counts.warn > 0 || counts.fail > 0

  return (
    <div
      className={cn(
        'flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] bg-foreground/5 border border-foreground/8',
      )}
      title={`Pass: ${counts.pass} / Warn: ${counts.warn} / Fail: ${counts.fail}${label ? ` (${label})` : ''}`}
    >
      <span className={cn('text-[8px] leading-none', dotColor)}>●</span>
      {hasIssues ? (
        <span className="text-muted-foreground font-medium">
          {counts.warn > 0 && (
            <span className="text-amber-500">W{counts.warn}</span>
          )}
          {counts.warn > 0 && counts.fail > 0 && (
            <span className="text-muted-foreground mx-0.5">/</span>
          )}
          {counts.fail > 0 && (
            <span className="text-red-500">F{counts.fail}</span>
          )}
        </span>
      ) : (
        <span className="text-success font-medium">{counts.pass}</span>
      )}
      {label && (
        <span className="text-muted-foreground/60 font-normal">{label}</span>
      )}
    </div>
  )
}

// Mock data for development
export const MOCK_BADGE_COUNTS: ValidationCount = { pass: 3, warn: 1, fail: 0 }
